'use client';

import { useCallback } from 'react';
import { useTour } from '../hooks/useTour';
import { useCompleteTourWithTracking } from '../hooks/useCompleteTourWithTracking';
import { WhyVoleyModal } from './WhyVoleyModal';

/**
 * WhyVoleyTourOverlay - Renders the "Why Voley?" sales walkthrough.
 *
 * Entirely modal-based — no navigation or element highlighting needed.
 */
export function WhyVoleyTourOverlay() {
  const { isActive, activeTourId, currentStep } = useTour();
  const { completeTourWithTracking } = useCompleteTourWithTracking();

  const isWhyVoleyTour = activeTourId === 'why-voley';

  const handleFinish = useCallback(() => {
    completeTourWithTracking('why-voley');
  }, [completeTourWithTracking]);

  if (!isWhyVoleyTour || !isActive || !currentStep) return null;

  return <WhyVoleyModal onFinish={handleFinish} />;
}
